export const AboutPage = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              About AvtechAI
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Passionate about transforming businesses through innovative
              technology solutions
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Meet Balu Vyamajala
              </h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  With over 15 years of experience in software development and
                  cloud technologies, I am a Principal Software Engineer who has
                  led teams and delivered innovative solutions for Fortune 500
                  companies.
                </p>
                <p>
                  My journey began as the first employee of Initech Global
                  India, where I built my expertise in complex web applications,
                  cloud migration, and DevOps practices. Throughout my career, I
                  have successfully executed over 50 projects with a 100%
                  success rate.
                </p>
                <p>
                  I specialize in building scalable, secure, and cost-effective
                  solutions using serverless-microservice architecture with SQL
                  and NoSQL databases. My passion lies in continuous learning
                  and making projects better with each iteration.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <h3 className="text-xl font-bold text-gray-900 mb-6">
                Key Achievements
              </h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="text-gray-600">
                    Won CIO award for saving $300,000 per month for a client
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="text-gray-600">
                    Led and mentored teams of up to 15 developers
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="text-gray-600">
                    Architected and delivered 50+ successful projects
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <p className="text-gray-600">
                    Multiple AWS certifications in cloud technologies
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Technical Expertise
            </h2>
            <p className="text-xl text-gray-600">
              Comprehensive skills across the full technology stack
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Programming Languages */}
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-lg font-bold text-gray-900 mb-4">
                Programming Languages
              </h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Java</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Node.js</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">JavaScript/TypeScript</span>
                </div>
              </div>
            </div>

            {/* Frameworks */}
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-lg font-bold text-gray-900 mb-4">
                Frameworks
              </h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Spring Boot</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">React</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Angular</span>
                </div>
              </div>
            </div>

            {/* Cloud Platforms */}
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-lg font-bold text-gray-900 mb-4">
                Cloud Platforms
              </h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">AWS</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">CDK</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">CloudFormation</span>
                </div>
              </div>
            </div>

            {/* Databases */}
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-lg font-bold text-gray-900 mb-4">
                Databases
              </h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">MySQL</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">PostgreSQL</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">DynamoDB</span>
                </div>
              </div>
            </div>

            {/* Streaming */}
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-lg font-bold text-gray-900 mb-4">
                Streaming Platforms
              </h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Kafka</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Kinesis</span>
                </div>
              </div>
            </div>

            {/* DevOps */}
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-lg font-bold text-gray-900 mb-4">
                CI/CD & DevOps
              </h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">AWS Pipelines</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Github Workflows</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Bitbucket Pipelines</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              AWS Certifications
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Certified expertise in Amazon Web Services technologies
            </p>
            <a
              href="https://www.credly.com/users/bala-subramanyam-vyamajala-venkata/badges"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
            >
              View All Certifications
              <svg
                className="w-4 h-4 ml-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* Company Mission */}
      <section className="bg-blue-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">Our Mission</h2>
          <p className="text-xl text-blue-100 max-w-4xl mx-auto leading-relaxed">
            At AvtechAI, we believe in the power of technology to transform
            businesses. Our mission is to bridge the gap between complex
            technical solutions and business value, delivering innovative
            applications that drive growth and efficiency. We start every day
            asking: "What can we learn new today, and how can we make our
            solutions better?"
          </p>
        </div>
      </section>
    </div>
  );
};
